import React from 'react'
import { useIntl } from 'react-intl'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { getPlural } from 'lib/string/pluralize'

interface Props {
  saleUnit: string
}

function PreSelectionBanner({ saleUnit }: Props) {
  const intl = useIntl()
  return (
    <MessageBanner
      kind="promotional-primary"
      density="compact"
    >
      {intl.formatMessage(
        {
          id: 'VlZDqde2ce',
          defaultMessage: 'We’ve pre-selected the best-value {pluralSaleUnit} to get you started. Customise each {saleUnit} below.',
          description: 'Banner message explaining auto-selected best-value room packages',
        },
        { pluralSaleUnit: getPlural(saleUnit), saleUnit },
      )}
    </MessageBanner>
  )
}

export default PreSelectionBanner
